import type { PointerEvent } from "react";

/** A message's actions show on mouse hover; a touch screen has no hover, so there they are always shown. */
export const SHOW_ON_HOVER_OR_TOUCH =
  "opacity-0 group-hover:opacity-100 [@media(hover:none)]:opacity-100 transition-opacity";

/** Extra padding that gives a text or icon button in a message's footer a finger-sized target on touch screens. */
export const FINGER_PADDING = "[@media(hover:none)]:px-2 [@media(hover:none)]:py-2.5";

// A finger's tap also fires pointer-enter and -leave. Only a mouse or pen hovers: for a
// finger the tap's own click opens the popup, and a tap elsewhere closes it.
const isMouseOrPen = (e: PointerEvent) => e.pointerType !== "touch";

/** Pointer handlers that run `enter` and `leave` for a mouse or pen, never for a finger. */
export const hoverHandlers = (enter: () => void, leave: () => void) => ({
  onPointerEnter: (e: PointerEvent) => {
    if (isMouseOrPen(e)) enter();
  },
  onPointerLeave: (e: PointerEvent) => {
    if (isMouseOrPen(e)) leave();
  },
});
